/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BRouteImport } from './routes/b'
import { Route as BetaRouteImport } from './routes/beta'
import { Route as BetaAdminRouteImport } from './routes/beta-admin'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as KeyHandoffRouteImport } from './routes/key-handoff'
import { Route as MisionbankeditorRouteImport } from './routes/misionbankeditor'
import { Route as MissionkitRouteImport } from './routes/missionkit'
import { Route as StartRouteImport } from './routes/start'
import { Route as CodeCodeRouteImport } from './routes/code.$code'
import { Route as DossierTokenRouteImport } from './routes/dossier.$token'
import { Route as ChoosemissionCodeCodeRouteImport } from './routes/choosemission.code.$code'
import { Route as KeyHandoffCodeCodeRouteImport } from './routes/key-handoff_.code.$code'
import { Route as MissionkitCodeCodeMissionIdRouteImport } from './routes/missionkit_.code.$code.$missionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BRoute = BRouteImport.update({
  id: '/b',
  path: '/b',
  getParentRoute: () => rootRouteImport,
} as any)
const BetaRoute = BetaRouteImport.update({
  id: '/beta',
  path: '/beta',
  getParentRoute: () => rootRouteImport,
} as any)
const BetaAdminRoute = BetaAdminRouteImport.update({
  id: '/beta-admin',
  path: '/beta-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const KeyHandoffRoute = KeyHandoffRouteImport.update({
  id: '/key-handoff',
  path: '/key-handoff',
  getParentRoute: () => rootRouteImport,
} as any)
const MisionbankeditorRoute = MisionbankeditorRouteImport.update({
  id: '/misionbankeditor',
  path: '/misionbankeditor',
  getParentRoute: () => rootRouteImport,
} as any)
const MissionkitRoute = MissionkitRouteImport.update({
  id: '/missionkit',
  path: '/missionkit',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const CodeCodeRoute = CodeCodeRouteImport.update({
  id: '/code/$code',
  path: '/code/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const DossierTokenRoute = DossierTokenRouteImport.update({
  id: '/dossier/$token',
  path: '/dossier/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ChoosemissionCodeCodeRoute = ChoosemissionCodeCodeRouteImport.update({
  id: '/choosemission/code/$code',
  path: '/choosemission/code/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const KeyHandoffCodeCodeRoute = KeyHandoffCodeCodeRouteImport.update({
  id: '/key-handoff_/code/$code',
  path: '/key-handoff/code/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const MissionkitCodeCodeMissionIdRoute =
  MissionkitCodeCodeMissionIdRouteImport.update({
    id: '/missionkit_/code/$code/$missionId',
    path: '/missionkit/code/$code/$missionId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/b': typeof BRoute
  '/beta': typeof BetaRoute
  '/beta-admin': typeof BetaAdminRoute
  '/chat': typeof ChatRoute
  '/key-handoff': typeof KeyHandoffRoute
  '/misionbankeditor': typeof MisionbankeditorRoute
  '/missionkit': typeof MissionkitRoute
  '/start': typeof StartRoute
  '/code/$code': typeof CodeCodeRoute
  '/dossier/$token': typeof DossierTokenRoute
  '/choosemission/code/$code': typeof ChoosemissionCodeCodeRoute
  '/key-handoff/code/$code': typeof KeyHandoffCodeCodeRoute
  '/missionkit/code/$code/$missionId': typeof MissionkitCodeCodeMissionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/b': typeof BRoute
  '/beta': typeof BetaRoute
  '/beta-admin': typeof BetaAdminRoute
  '/chat': typeof ChatRoute
  '/key-handoff': typeof KeyHandoffRoute
  '/misionbankeditor': typeof MisionbankeditorRoute
  '/missionkit': typeof MissionkitRoute
  '/start': typeof StartRoute
  '/code/$code': typeof CodeCodeRoute
  '/dossier/$token': typeof DossierTokenRoute
  '/choosemission/code/$code': typeof ChoosemissionCodeCodeRoute
  '/key-handoff/code/$code': typeof KeyHandoffCodeCodeRoute
  '/missionkit/code/$code/$missionId': typeof MissionkitCodeCodeMissionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/b': typeof BRoute
  '/beta': typeof BetaRoute
  '/beta-admin': typeof BetaAdminRoute
  '/chat': typeof ChatRoute
  '/key-handoff': typeof KeyHandoffRoute
  '/misionbankeditor': typeof MisionbankeditorRoute
  '/missionkit': typeof MissionkitRoute
  '/start': typeof StartRoute
  '/code/$code': typeof CodeCodeRoute
  '/dossier/$token': typeof DossierTokenRoute
  '/choosemission/code/$code': typeof ChoosemissionCodeCodeRoute
  '/key-handoff_/code/$code': typeof KeyHandoffCodeCodeRoute
  '/missionkit_/code/$code/$missionId': typeof MissionkitCodeCodeMissionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/b'
    | '/beta'
    | '/beta-admin'
    | '/chat'
    | '/key-handoff'
    | '/misionbankeditor'
    | '/missionkit'
    | '/start'
    | '/code/$code'
    | '/dossier/$token'
    | '/choosemission/code/$code'
    | '/key-handoff/code/$code'
    | '/missionkit/code/$code/$missionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/b'
    | '/beta'
    | '/beta-admin'
    | '/chat'
    | '/key-handoff'
    | '/misionbankeditor'
    | '/missionkit'
    | '/start'
    | '/code/$code'
    | '/dossier/$token'
    | '/choosemission/code/$code'
    | '/key-handoff/code/$code'
    | '/missionkit/code/$code/$missionId'
  id:
    | '__root__'
    | '/'
    | '/b'
    | '/beta'
    | '/beta-admin'
    | '/chat'
    | '/key-handoff'
    | '/misionbankeditor'
    | '/missionkit'
    | '/start'
    | '/code/$code'
    | '/dossier/$token'
    | '/choosemission/code/$code'
    | '/key-handoff_/code/$code'
    | '/missionkit_/code/$code/$missionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BRoute: typeof BRoute
  BetaRoute: typeof BetaRoute
  BetaAdminRoute: typeof BetaAdminRoute
  ChatRoute: typeof ChatRoute
  KeyHandoffRoute: typeof KeyHandoffRoute
  MisionbankeditorRoute: typeof MisionbankeditorRoute
  MissionkitRoute: typeof MissionkitRoute
  StartRoute: typeof StartRoute
  CodeCodeRoute: typeof CodeCodeRoute
  DossierTokenRoute: typeof DossierTokenRoute
  ChoosemissionCodeCodeRoute: typeof ChoosemissionCodeCodeRoute
  KeyHandoffCodeCodeRoute: typeof KeyHandoffCodeCodeRoute
  MissionkitCodeCodeMissionIdRoute: typeof MissionkitCodeCodeMissionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/b': {
      id: '/b'
      path: '/b'
      fullPath: '/b'
      preLoaderRoute: typeof BRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beta': {
      id: '/beta'
      path: '/beta'
      fullPath: '/beta'
      preLoaderRoute: typeof BetaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beta-admin': {
      id: '/beta-admin'
      path: '/beta-admin'
      fullPath: '/beta-admin'
      preLoaderRoute: typeof BetaAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/key-handoff': {
      id: '/key-handoff'
      path: '/key-handoff'
      fullPath: '/key-handoff'
      preLoaderRoute: typeof KeyHandoffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/misionbankeditor': {
      id: '/misionbankeditor'
      path: '/misionbankeditor'
      fullPath: '/misionbankeditor'
      preLoaderRoute: typeof MisionbankeditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/missionkit': {
      id: '/missionkit'
      path: '/missionkit'
      fullPath: '/missionkit'
      preLoaderRoute: typeof MissionkitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/code/$code': {
      id: '/code/$code'
      path: '/code/$code'
      fullPath: '/code/$code'
      preLoaderRoute: typeof CodeCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dossier/$token': {
      id: '/dossier/$token'
      path: '/dossier/$token'
      fullPath: '/dossier/$token'
      preLoaderRoute: typeof DossierTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/choosemission/code/$code': {
      id: '/choosemission/code/$code'
      path: '/choosemission/code/$code'
      fullPath: '/choosemission/code/$code'
      preLoaderRoute: typeof ChoosemissionCodeCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/key-handoff_/code/$code': {
      id: '/key-handoff_/code/$code'
      path: '/key-handoff/code/$code'
      fullPath: '/key-handoff/code/$code'
      preLoaderRoute: typeof KeyHandoffCodeCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/missionkit_/code/$code/$missionId': {
      id: '/missionkit_/code/$code/$missionId'
      path: '/missionkit/code/$code/$missionId'
      fullPath: '/missionkit/code/$code/$missionId'
      preLoaderRoute: typeof MissionkitCodeCodeMissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BRoute: BRoute,
  BetaRoute: BetaRoute,
  BetaAdminRoute: BetaAdminRoute,
  ChatRoute: ChatRoute,
  KeyHandoffRoute: KeyHandoffRoute,
  MisionbankeditorRoute: MisionbankeditorRoute,
  MissionkitRoute: MissionkitRoute,
  StartRoute: StartRoute,
  CodeCodeRoute: CodeCodeRoute,
  DossierTokenRoute: DossierTokenRoute,
  ChoosemissionCodeCodeRoute: ChoosemissionCodeCodeRoute,
  KeyHandoffCodeCodeRoute: KeyHandoffCodeCodeRoute,
  MissionkitCodeCodeMissionIdRoute: MissionkitCodeCodeMissionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
